import { Injectable } from '@angular/core';


import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';

import * as fromStore from '../store';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SocialChannelsGuard  {
  constructor(private store: Store<fromStore.SocialMediaState>) {}

  canActivate(): Observable<boolean> {
    return this.checkStore().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(): Observable<boolean> {
    return this.store.select(fromStore.getSocialChannelsLoaded).pipe(
      tap(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.LoadSocialChannels());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
